/*
* Class for rendering components in the editor on first draw or on adding new component from menu
* */

import {PublicTabs} from "../components/tabsSection/core/publicTabs.js";
const PublicTabsInstance = new PublicTabs();
import PopupClass from "../../components/common/PopupClass.js";

import {headingSection} from "../components/headingSection/headingSection.js";
import {imageSection} from "../components/imageSection/imageSection.js";
import {labeledImageSection} from "../components/labeledImageSection/labeledImageSection.js";
import {listSection} from "../components/listSection/listSection.js";
import {paragraphSection} from "../components/paragraphSection/paragraphSection.js";
import {sortingActivitySection} from "../components/sortingActivitySection/sortingActivitySection.js";
import {statementSection} from "../components/statementSection/statementSection.js";
import {twoColumnsSection} from "../components/twoColumnsSection/twoColumnsSection.js";
import {dividerSection} from "../components/dividerSection/dividerSection.js";
import {accordionSection} from "../components/accordionSection/accordionSection.js";
import {tabsSection} from "../components/tabsSection/tabsSection.js";
import {tableSection} from "../components/tableSection/tableSection.js";
import {imageTextSection} from "../components/imageTextSection/imageTextSection.js";
import {timelineSection} from "../components/timelineSection/timelineSection.js";
import {gallerySection} from "../components/gallerySection/gallerySection.js";
import {flashcardSection} from "../components/flashcardSection/flashcardSection.js";
import {matchingSection} from "../components/matchingSection/matchingSection.js";
import {sortingSection} from "../components/sortingSection/sortingSection.js";
import {choiceSection} from "../components/choiceSection/choiceSection.js";
import {videoSection} from "../components/videoSection/videoSection.js";
import {componentsHelper} from "../helpers/componentsHelper.js";
import MatchingRun from "../components/matchingSection/core/MatchingRun";


export class EditorComponentsRendering{
    constructor(component_name, param = null, is_new, ai = false) {
        this.component = component_name;
        this.param = param ? param : {};
        this.param.id = is_new ? 'component_' + Math.floor(Math.random() * 1000000) : this.param.id;

    }

    get id() {
        return this.param.id;
    }

    async run() {
        let html = '';
        console.log(this.param)
        switch (this.component) {
            case 'headingSection':
                html = headingSection(this.param);
                break;
            case 'imageSection':
                html = imageSection(this.param);
                break;
            case 'labeledImageSection':
                html = labeledImageSection(this.param);
                break;
            case 'listSection':
                html = listSection(this.param);
                break;
            case 'paragraphSection':
                html = paragraphSection(this.param);
                break;
            case 'sortingActivitySection':
                html = sortingActivitySection(this.param);
                break;
            case 'statementSection':
                html = statementSection(this.param);
                break;
            case 'twoColumnsSection':
                html = twoColumnsSection(this.param);
                break;
            case 'dividerSection':
                html = dividerSection(this.param);
                break;
            case 'accordionSection':
                html = accordionSection(this.param);
                break;
            case 'tableSection':
                html = tableSection(this.param);
                break;
            case 'imageTextSection':
                html = imageTextSection(this.param);
                break;
            case 'timelineSection':
                html = timelineSection(this.param);
                break;
            case 'gallerySection':
                html = gallerySection(this.param);
                setTimeout(() => {
                    const vsPopupInit = new PopupClass();
                }, 100);
                break;
            case 'flashcardSection':
                html = flashcardSection(this.param);
                break;
            case 'matchingSection':
                html = matchingSection(this.param);
                setTimeout(() => {
                    new MatchingRun();
                }, 100);
                break;
            case 'sortingSection':
                html = sortingSection(this.param);
                break;
            case 'choiceSection':
                html = choiceSection(this.param);
                break;
            case 'videoSection':
                html = videoSection(this.param);
                break;
            case 'tabsSection':
                html = tabsSection(this.param);
                setTimeout(() => {
                    PublicTabsInstance.scrollTabsHeader();
                }, 100);
                break;
            default:
                html = '';
                break;
        }
        // setTimeout(() => {
        //     componentsHelper.contentEditableFix();
        // }, 200);
        return html;
    }
}
